/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Action_View_CaseInputs */

const en_notifications_action_view_case = /** @type {(inputs: Notifications_Action_View_CaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View case`)
};

const pt_br2_notifications_action_view_case = /** @type {(inputs: Notifications_Action_View_CaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver caso`)
};

/**
* | output |
* | --- |
* | "View case" |
*
* @param {Notifications_Action_View_CaseInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const notifications_action_view_case = /** @type {((inputs?: Notifications_Action_View_CaseInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Action_View_CaseInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_notifications_action_view_case(inputs)
	return pt_br2_notifications_action_view_case(inputs)
});